var mapStyle = [
    {
        "featureType": "administrative",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            },
            {
                "saturation": "-77"
            },
            {
                "weight": "1.23"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#848ea4"
            },
            {
                "saturation": "-66"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "visibility": "on"
            },
            {
                "saturation": "-54"
            },
            {
                "lightness": "16"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "saturation": "46"
            },
            {
                "lightness": "32"
            },
            {
                "color": "#eaeaea"
            },
            {
                "weight": "1.12"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "saturation": "-80"
            },
            {
                "lightness": "-90"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "saturation": "-80"
            },
            {
                "lightness": "-70"
            },
            {
                "visibility": "off"
            },
            {
                "gamma": "1"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": "-20"
            },
            {
                "lightness": "36"
            },
            {
                "visibility": "on"
            },
            {
                "weight": "0.4"
            },
            {
                "color": "#767676"
            },
            {
                "gamma": "1.85"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "saturation": "-70"
            },
            {
                "lightness": "50"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "all",
        "stylers": [
            {
                "saturation": "38"
            },
            {
                "lightness": "59"
            },
            {
                "visibility": "on"
            },
            {
                "color": "#888888"
            },
            {
                "weight": "0.25"
            },
            {
                "gamma": "1.37"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "color": "#a6a6a6"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "lightness": "0"
            },
            {
                "saturation": "0"
            },
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#0060ff"
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "hue": "#0066ff"
            },
            {
                "saturation": "0"
            },
            {
                "lightness": 100
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "hue": "#000000"
            },
            {
                "saturation": -100
            },
            {
                "lightness": -100
            },
            {
                "visibility": "off"
            }
        ]
    }
]
const AppConstants = {}
AppConstants.install = function (Vue, options) {
	Vue.prototype.appConstants = {
		mapStyle: mapStyle,
		translations: {
			en: {
				writeToUs: 'Write to us',
				sendBtn: 'SEND',
				textareaPlaceholder: 'MESSAGE',
				getDirection: 'Get Direction',
				prevBtn: 'PREVIEWS PROJECT',
                nextBtn: 'NEXT PROJECT',
                searchPlaceholer: 'Search projects ...',
				name: 'Full name',
				errorMessage: 'I apologize for this inconvenience but there seems to have been an error when sending. Would it be possible to retransmit?',
                successMessage: 'Thank you for sending your message',
                search: 'Search...',
                searchResultFor: 'Search results for',
                resultsFound: 'results found'
			},
			de: {
				writeToUs: 'Schreiben Sie uns',
				sendBtn: 'SENDEN',
				textareaPlaceholder: 'NACHRICHT',
				getDirection: 'Holen Sie sich die Richtung',
				prevBtn: 'PRÄVIEWS PROJEKT',
                nextBtn: 'NÄCHSTES PROJEKT',
                searchPlaceholer: 'Projekte suchen ...',
				name: 'Name und vorname',
				errorMessage: `Nous vous prions de nous excuser pour le désagrément mais il semble qu'il y ait eu une erreur au moment de l'envoi. Serait-il possible de nous le renvoyer ?`,
                successMessage: 'Nous vous remercions pour votre message',
                search: 'Suche...',
                searchResultFor: 'Suchergebnisse für',
                resultsFound: 'gefundene Ergebnisse'
			 }    
		}
	}
}

export default AppConstants